import React, { ReactNode } from 'react';
import styled from 'styled-components';
import HBClickable from '../HBClickable/HBClickable';
import HBText from '../HBText/HBText';
import { TAllColorKeys } from '../HBText/HBText';

export interface IDrawerOption {
    closeDrawerOnClick?: boolean;
    icon?: React.ReactElement;
    onClick: () => void;
    subtitle?: string;
    testIdName: string;
    title: ReactNode;
    titleColor?: TAllColorKeys;
}

const DrawerOptionsListItem = ({
    closeDrawer,
    closeDrawerOnClick = true,
    icon: Icon,
    onClick,
    subtitle,
    testIdName,
    title,
    titleColor = 'text.primary'
}: IDrawerOption & {
    closeDrawer: () => void;
}) => {
    const handleClick = () => {
        if (closeDrawerOnClick) {
            closeDrawer();
        }
        onClick();
    };

    return (
        <GridContainer onClick={handleClick} testIdName={testIdName}>
            {Icon}
            {typeof title === 'string' ? (
                <Title color={titleColor}>{title}</Title>
            ) : (
                title
            )}
            {subtitle && <Subtitle>{subtitle}</Subtitle>}
        </GridContainer>
    );
};

export default DrawerOptionsListItem;

// -------------------------------- Styles -------------------------------- //
const GridContainer = styled(HBClickable)`
    display: grid;
    grid-template-columns: auto 1fr;
    grid-column-gap: 12px;
    padding: 16px 0;
    align-items: center;
`;

const Title = styled(HBText).attrs({ type: 'body18' })``;

const Subtitle = styled(HBText).attrs({
    type: 'body14',
    color: 'text.secondary'
})`
    grid-column: 2;
`;
